export const MULTI_USER_SELECTED_ALLOCATION = "MultiUserAllocationsPage_selectedAllocation";
export const QR_LOGIN = "QR_login";
export const IS_PROD = "isProd";